(function($) {
    class AnnouncementBar {
        constructor() {
            this.cookieName = 'announcement_bar_dismissed';
            this.initSelectors();
            this.bindEvents();
        }

        initSelectors() {
            this.announcement_bar = $('.announcement-bar');
            this.announcementBarCloseBtn = $('.announcement-bar__remove');
        }

        bindEvents() {
            this.announcementBarCloseBtn.on('click', (e) => this.closeAnnouncementBar(e));
        }

        closeAnnouncementBar(e) {
            this.announcement_bar.addClass('announcement-bar--hide');

            setTimeout(() => {
                this.announcement_bar.remove();
                document.body.style.removeProperty('--has-announcement-bar');
            }, 300);

            W4D_FrontendHelper.setCookie(this.cookieName, 'true', 7, 'Lax', false);
        }
    }

    $(document).ready(() => {
        new AnnouncementBar();
    });
})(jQuery);